import { useQueryClient } from '@tanstack/react-query';
import { ActivityLogWithDetail } from '../../../common/types/databaseTypes';
import { activityService } from './activityService';
import { useSafeQuery } from '@/common/hooks/useSafeQuery';

// useQueryClient를 사용하는 훅으로 변경
export function useInvalidateActivityLogs() {
    const queryClient = useQueryClient();
    return (goalId: string) => {
        void queryClient.invalidateQueries({
            queryKey: ['activityLogs', goalId],
        });
    };
}

// 활동 로그 조회 훅
export function useActivityLogs(goalId?: string) {
    return useSafeQuery<ActivityLogWithDetail[], Error>({
        queryKey: ['activityLogs', goalId],
        queryFn: () => activityService.fetchActivityLogs(goalId || ''),
        enabled: !!goalId,
        refetchOnWindowFocus: true,
        staleTime: 5000, // 5초 동안은 캐시된 데이터 사용
    });
}
